import axios from 'axios';
import Cookies from 'js-cookie';

export const setSession = (accessToken: string | null) => {
    if (accessToken) {
        Cookies.set('accessToken', accessToken);

        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
        Cookies.remove('accessToken');

        delete axios.defaults.headers.common.Authorization;
    }
};

export const clearAuthTokens = () => {
    Cookies.remove('accessToken');
    // Cookies.removeItem('refreshToken');
};

/** Normalize Laravel/Sanctum JSON body for `GET /me` (may be `{ data: { ... } }` or `{ user: { ... } }`). */
export function unwrapSanctumMeResponse(body: unknown): Record<string, unknown> | null {
    if (body == null || typeof body !== 'object') return null;
    const o = body as Record<string, unknown>;
    const data = o.data;
    if (data != null && typeof data === 'object' && !Array.isArray(data)) {
        return data as Record<string, unknown>;
    }
    const user = o.user;
    if (user != null && typeof user === 'object' && !Array.isArray(user)) {
        return user as Record<string, unknown>;
    }
    return o;
}
